import type { CSSProperties } from 'react';

export const PURPLE_NEBULA: CSSProperties = {
  background: [
    'linear-gradient(to bottom, rgba(0,0,0,1) 0%, rgba(0,0,0,0.85) 10%, rgba(0,0,0,0.2) 25%, rgba(0,0,0,0.0) 40%, rgba(0,0,0,0.0) 60%, rgba(0,0,0,0.2) 75%, rgba(0,0,0,0.85) 90%, rgba(0,0,0,1) 100%)',
    'linear-gradient(90deg, rgba(120,40,255,0.55), rgba(180,60,255,0.55))',
    'radial-gradient(1400px at 50% 40%, rgba(255,255,255,0.03), rgba(60,0,90,0) 75%)',
    'radial-gradient(1000px at 15% 35%, rgba(140,40,255,0.40), rgba(40,0,70,0) 75%)',
    'radial-gradient(900px at 55% 60%, rgba(160,50,255,0.30), rgba(35,0,60,0) 80%)',
    'radial-gradient(1000px at 85% 70%, rgba(200,70,255,0.40), rgba(45,0,70,0) 80%)',
    'radial-gradient(circle at 50% 50%, rgba(255,255,255,0.02) 0%, rgba(255,255,255,0.00) 60%)',
    'radial-gradient(circle at 50% 25%, #2a0050 0%, #1a0038 35%, #000000 75%, #000000 100%)',
  ].join(', '),
  backgroundBlendMode: 'normal, soft-light, overlay, screen, screen, screen, soft-light, multiply',
};

export const legalTitleStyle: CSSProperties = {
  fontFamily: 'Inter, sans-serif',
  fontWeight: 900,
  fontStyle: 'italic',
  letterSpacing: '-0.3px',
  color: '#fff',
  margin: 0,
  fontVariationSettings: "'wght' 900",
};

export const legalButtonBase: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '10px 28px',
  borderRadius: '30px',
  fontFamily: 'Inter, sans-serif',
  fontWeight: 600,
  fontSize: '14px',
  textDecoration: 'none',
  cursor: 'pointer',
  lineHeight: '22px',
  whiteSpace: 'nowrap',
};
